import { Seo } from '../components/Seo';

export function GuidelinePage() {
  return (
    <section className="stack-md">
      <Seo title="타로맨스 | Guideline" description="타로맨스 이용 가이드라인" />
      <article className="card">
        <h1>GUIDELINE</h1>
        <p>타로 상담 및 바 이용 시 기본 안내 사항입니다.</p>
        <ul>
          <li>운영시간: OPEN 17:00 / CLOSE 03:00 (연중무휴)</li>
          <li>타로상담 가능 시간: 일~금 19:00 - 03:00</li>
          <li>토요일은 바 운영 집중일로 타로상담이 진행되지 않습니다.</li>
          <li>19:00 이전 상담 문의는 오너 스케줄 확인 후 별도 안내될 수 있습니다.</li>
          <li>매장 내 촬영은 타인 프라이버시를 존중해 주세요.</li>
        </ul>
      </article>
    </section>
  );
}
